import { BaseViewStore } from 'core/stores';
import ChannelStore from './ChannelStore';
import { ApplicationStore } from 'platform/application/stores';
import { AmazonTemplatesForm } from 'modules/order/forms';
import { action, makeObservable } from 'mobx';
import { sourceOfChange, viewStoreName } from 'common/constants';
import _ from 'lodash';
import { BaasicDropdownViewStore } from 'common/stores';

class AmazonTemplatesViewStore extends BaseViewStore {
	channel;
	amazonTemplates = [];
	form = new AmazonTemplatesForm({
		onSuccess: async () => {
			await this.updateChannelAmazonTemplates();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.channelStore = new ChannelStore(rootStore);
		this.applicationStore = new ApplicationStore(rootStore);
		this.isListOrEditStore =
			modalParams.data.store_path === viewStoreName.channelListViewStore || modalParams.data.isEdit;
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		let credentials = null;
		if (this.modalParams.data.store_path === viewStoreName.channelListViewStore) {
			credentials = {
				amazonSellerId: this.modalParams.data.selectedItem.amazonSellerId,
				marketplaceId: this.modalParams.data.selectedItem.marketplaceId,
				refreshToken: this.modalParams.data.selectedItem.refreshToken
			}
		}
		else {
			const { amazonSellerId, marketplaceId, refreshToken } = this.modalParams.data.form.values();
			credentials = {
				amazonSellerId,
				marketplaceId,
				refreshToken
			}
		}

		try {
			this.templatesFromChannel = await this.channelStore.getAmazonTemplates(credentials);

			if (this.templatesFromChannel && this.templatesFromChannel.length === 0) {
				this.rootStore.notificationStore.error(['AMAZONTEMPLATES.MISSINGTEMPLATES']);
			}
		} catch (error) {
			this.rootStore.notificationStore.error(['AMAZONTEMPLATES.FETCHERROR']);
		}

		if (this.isListOrEditStore) {
			this.channel = await this.channelStore.getChannel(this.modalParams.data.selectedItem.id, {
				embed: ['seller', 'amazonTemplates', 'channelType'],
			});

			this.amazonTemplatesModel = {
				amazonTemplates: this.channel.amazonTemplates,
				defaultPrimeTemplate: this.channel.defaultPrimeTemplate,
			};
		} else {
			this.amazonTemplatesModel = this.modalParams.data.amazonTemplatesModel;
		}
		await this.prepareData();
		this.resume();
	};

	@action.bound
	addAmazonTemplate = async () => {
		this.form.$('amazonTemplates').add([
			{
				systemCode: '',
				amazonCodeId: '',
			},
		]);

		const field = this.form.$('amazonTemplates').$(this.form.$('amazonTemplates').value.length - 1);

		field.templateDropdownStore = new BaasicDropdownViewStore();
		await field.templateDropdownStore.initialize({
			field: field.$('amazonCodeId'),
			staticOptions: this.templatesFromChannel,
		});
	};

	@action.bound
	prepareData = async () => {
		for (const amazonTemplate of this.amazonTemplatesModel.amazonTemplates) {
			this.form.$('amazonTemplates').add([
				{
					systemCode: amazonTemplate.systemCode,
					amazonCodeId: amazonTemplate.amazonCodeId,
				},
			]);
			const field = this.form.$('amazonTemplates').$(this.form.$('amazonTemplates').value.length - 1);

			field.templateDropdownStore = new BaasicDropdownViewStore();
			await field.templateDropdownStore.initialize({
				field: field.$('amazonCodeId'),
				value: { value: amazonTemplate.amazonCodeId, label: amazonTemplate.amazonCode },
				staticOptions: this.templatesFromChannel,
			});
		}
		this.form.$('defaultPrimeTemplate').value = this.amazonTemplatesModel.defaultPrimeTemplate;
	};

	@action.bound
	updateChannelAmazonTemplates = async () => {
		this.suspend();
		try {
			let amazonTemplates = [];
			for (const fieldInfo of this.form.$('amazonTemplates').fields) {
				let field = fieldInfo[1];
				amazonTemplates.push({
					systemCode: field.$('systemCode').value,
					amazonCode: field.templateDropdownStore.value.label,
					amazonCodeId: field.$('amazonCodeId').value,
				});
			}

			if (this.isListOrEditStore) {
				await this.channelStore.updateChannelAmazonTemplates(
					{
						channelId: this.channel.id,
						amazonTemplates,
					},
					this.modalParams.data.store_path === 'channelListViewStore'
						? sourceOfChange.channelListUpdatelAmazonTemplates
						: sourceOfChange.channelEditUpdateAmazonTemplates
				);
				this.rootStore.notificationStore.success(['AMAZONTEMPLATES.SUCCESS', { channelName: this.channel.name }]);
			} else {
				this.modalParams.data.amazonTemplatesModel = { amazonTemplates, defaultPrimeTemplate: '' };
				this.rootStore.notificationStore.success(['AMAZONTEMPLATES.UPDATED']);
			}
			this.modalParams.success();
		} catch (err) {
			this.rootStore.notificationStore.error(['AMAZONTEMPLATES.ERROR', { channelName: this.channel.name }]);
		}
		this.resume();
	};
}

export default AmazonTemplatesViewStore;
